import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Stack,
  Typography,
  Box,
  Drawer,
  IconButton,
  Dialog,
} from '@mui/material';
import Iconify from '../../components/Iconify';
import useMobile from '../../hooks/useMobile';
import { useModals } from '@mattjennings/react-modal-stack';
import PromotionForm from './PromotionForm';

function PromotionModal({ open }) {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const { closeModal } = useModals();

  useEffect(() => {
    return () => {
      window.dispatchEvent(new CustomEvent('promotion-modal-closed'));
    };
  }, []);

  const onSubmitHandler = () => {
    closeModal();
  };

  const Component = isMobile ? Drawer : Dialog;

  return (
    <Component
      anchor="bottom"
      open={open}
      onClose={() => {
        closeModal();
      }}
    >
      <Box sx={{ width: '100%', height: '100%', padding: '32px' }}>
        <Stack
          direction="row"
          sx={{
            mb: '8px',
          }}
        >
          <Box sx={{ minWidth: 160 }}>
            <Typography variant="subtitle1" sx={{}}>
              {t('checkout.coupons.add')}
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1 }}></Box>
          <IconButton sx={{ mt: -0.8 }} onClick={() => closeModal()}>
            <Iconify
              sx={{ color: 'black' }}
              width={20}
              height={20}
              icon={'material-symbols:close'}
            />
          </IconButton>
        </Stack>
        <Box
          sx={{
            'width': '100%',
            '& form': {
              width: '100%',
            },
          }}
        >
          <PromotionForm onSubmit={onSubmitHandler} />
        </Box>
      </Box>
    </Component>
  );
}

export default PromotionModal;
